import { render, staticRenderFns } from "./discrepancy-transaction-action-column.vue?vue&type=template&id=23177fbc&scoped=true"
import script from "./discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
export * from "./discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
import style0 from "./discrepancy-transaction-action-column.vue?vue&type=style&index=0&id=23177fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23177fbc",
  null
  
)

export default component.exports